<template>
    <button :type="type" :class="buttonClass" :disabled="disabled" @click="submitButton">
        <i :class="iconClass" v-if="icon"></i>
        <slot/>
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            color: {
                type: String,
                default: 'primary',
            },
            icon: String,
            disabled: Boolean,
            large: Boolean,
            small: Boolean,
            space: Boolean,
            hSpace: Boolean,
            vSpace: Boolean,
        },

        computed: {
            buttonClass: vm => ({
                btn: true,
                'btn-lg': vm.large,
                'btn-sm': vm.small,
                'btn-space': vm.space,
                'btn-hspace': vm.hSpace,
                'btn-vspace': vm.vSpace,
                [`btn-${vm.color}`]: true,
            }),

            iconClass: vm => ({
                icon: true,
                'icon-left': !!vm.$slots.default,
                mdi: true,
                [`mdi-${vm.icon}`]: true,
            }),
        },

        methods: {
            submitButton(e) {
                if (this.type !== 'submit') {
                    e.preventDefault();
                }

                this.$emit('click');
            },
        },
    };
</script>
